module.exports = __webpack_public_path__ + "static/media/5loyalty-white.994ee3c0.svg";